import React from "react";
import AboutUs from "./AboutUs";
import HeroSection from "./HeroSection";
import Affiliations from "./Affilations";
import SignUpCTA from "./SignUpCTA";
import AboutFounder from "./AboutFounder";
import Services from "./Services";
import ClassTypes from "./ClassTypes";

const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <Affiliations />
      <ClassTypes />
      <AboutUs />
      <Services />
      <AboutFounder />
      <SignUpCTA />
    </>
  );
};

export default LandingPage;
